import React from 'react';

interface DinoLogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
  variant?: 'icon' | 'full' | 'wordmark';
}

export function DinoLogo({ 
  size = 40, 
  className = "", 
  showText = true, 
  variant = 'full' 
}: DinoLogoProps) {
  const DinoIcon = () => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Simplified Dino body */}
      <ellipse cx="50" cy="55" rx="25" ry="20" fill="hsl(82, 60%, 34%)" />
      
      {/* Dino head */}
      <circle cx="65" cy="35" r="15" fill="hsl(82, 60%, 34%)" />
      
      {/* Book spikes on back */}
      <rect x="35" y="35" width="8" height="15" rx="2" fill="hsl(335, 42%, 40%)" />
      <rect x="25" y="30" width="8" height="20" rx="2" fill="hsl(335, 42%, 40%)" />
      <rect x="45" y="38" width="8" height="12" rx="2" fill="hsl(335, 42%, 40%)" />
      
      {/* White page details on books */}
      <rect x="37" y="37" width="4" height="13" fill="white" opacity="0.7" />
      <rect x="27" y="32" width="4" height="18" fill="white" opacity="0.7" />
      <rect x="47" y="40" width="4" height="10" fill="white" opacity="0.7" />
      
      {/* Dino legs */}
      <rect x="35" y="70" width="8" height="12" rx="4" fill="hsl(82, 60%, 34%)" />
      <rect x="55" y="70" width="8" height="12" rx="4" fill="hsl(82, 60%, 34%)" />
      
      {/* Dino tail */}
      <path d="M 25 60 Q 15 65 20 75" stroke="hsl(82, 60%, 34%)" strokeWidth="8" fill="none" strokeLinecap="round" />
      
      {/* Dino eye */}
      <circle cx="70" cy="33" r="3" fill="hsl(140, 35%, 17%)" />
      
      {/* Smile */}
      <path d="M 63 40 Q 68 43 73 40" stroke="hsl(140, 35%, 17%)" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );

  if (variant === 'icon') {
    return <DinoIcon />;
  }

  if (variant === 'wordmark') {
    return (
      <div className={`flex items-center ${className}`}>
        <span className="font-heading font-bold text-3xl tracking-tight text-foreground">
          Dino
        </span>
      </div>
    );
  }

  // Full logo with icon and text
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <DinoIcon />
      {showText && (
        <span className="font-heading font-bold text-3xl tracking-tight text-foreground">
          Dino
        </span>
      )}
    </div>
  );
}

// Tagline component
export function DinoTagline({ className = "" }: { className?: string }) {
  return (
    <p className={`font-accent text-muted-foreground ${className}`}>
      Your playful reading companion 🦕
    </p>
  );
}
